import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS, Pin } from 'common/constants';
import { OTHER_PROPS } from 'common/constants/component-props';
import { SHAPE_TYPE } from 'common/building-blocks/shape/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const resultShape = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.RESULT_SHAPE> =>
	createModel({
		type: COMPONENT_TYPE.RESULT_SHAPE,
		editorProps: {
			draggable: false,
		},
		componentProps: {
			other: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[OTHER_PROPS.shape.shapeType]: SHAPE_TYPE.RECT,
						[OTHER_PROPS.pin.pinType]: Pin.b,
					},
				},
			},
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						justifySelf: 'stretch',
						alignSelf: 'end',
						left: 'auto',
						top: '-0.86vw',
						height: '0.94vw',
					},
				},
			},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.RESULT_SHAPE>;
